import { Backdrop, CircularProgress } from '@mui/material'; // Import Backdrop and CircularProgress from Material UI
import Breadcrumbs from "components/ppa-quote/Breadcrumbs";
import QuotesTable from "components/ppa-quote/QuotesTable";
import UserContext from "Context/UserProvider";
import { useContext, useEffect, useState } from "react";
import toast from 'react-hot-toast';
import { useLocation } from "react-router";
import { useNavigate } from "react-router-dom";
import { useApiService } from "../../services/ApiService/ApiService";


function BuildQuotePageResults(props: any) {
    const { userInfo } = useContext(UserContext);
    const [loading, setLoading] = useState(true);
    const location = useLocation() as any;
    const [isDisabled, setIsDisabled] = useState<boolean>(false);
    const navigate = useNavigate();
    const [isError, setIsError] = useState(false);
    const [totalMonthlyPublicKWh, setTotalMonthlyPublicKWh] = useState<number>();
    const quickQuote = location?.state?.quickQuote; // Receiving quickQuote from the previous page
    const { fetchWithAuth } = useApiService();

    const [quotes, setQuotes] = useState([]) as any


    async function fetchQuotes() {
        try {
            const response = await fetchWithAuth('/ppa/advanced/build/quotes/get', {
                method: 'POST',
                body: JSON.stringify({
                    uuid: userInfo.uuid,
                    accountUuid: userInfo.accountUuid,
                    fleetScenarioUuidList: location.state.fleetScenarioUuidList,
                    electricVehicleFleetUuidList: location.state.electricVehicleFleetUuidList,
                    quickQuote: quickQuote
                })
            });

            if (!response.ok) {
                throw new Error('Failed to fetch quotes');
            }

            const res_json = await response.json();
            setQuotes(res_json.quotes);
            setTotalMonthlyPublicKWh(res_json.totalMonthlyPublicKWh);
        } catch (error) {
            console.error('Error fetching quotes:', error);
            setIsError(true);
        } finally {
            setLoading(false);
        }
    }

    const acceptQuote = async (chargePointOperatorUuid: string, chargingPartnerRateCardUuid: string, rowId: any) => {
        setIsDisabled(true);
        try {
            const response = await fetchWithAuth('/ppa/advanced/build/agreement/create', {
                method: 'POST',
                body: JSON.stringify({
                    uuid: userInfo.uuid,
                    businessUuid: userInfo.businessUuid,
                    accountUuid: userInfo.accountUuid,
                    chargePointOperatorUuid,
                    chargingPartnerRateCardUuid,
                    fleetScenarioUuidList: location.state.fleetScenarioUuidList,
                    electricVehicleFleetUuidList: location.state.electricVehicleFleetUuidList,
                    totalMonthlyPublicKWh,
                    quickQuote
                })
            });

            if (!response.ok) {
                const res_json = await response.json();
                throw new Error(res_json.message || 'Failed to create agreement');
            }

            const res_json = await response.json();
            const updatedData = quotes.map((row: { id: any; }) =>
                row.id === rowId ? { ...row, workflowState: res_json.workflowState } : row
            );
            setQuotes(updatedData);
            toast.success('Power Purchase Agreement setup Successful', {
                position: 'bottom-center',
                duration: 5000,
            });
            navigate("/agree/ppa/list");
        } catch (error) {
            console.error('Error creating agreement:', error);
            toast.error('Unable to create agreement at this time.', {
                position: 'bottom-center',
                duration: 5000,
            });
        } finally {
            setIsDisabled(false);
        }
    };

    useEffect(() => {
        console.log("use " + JSON.stringify(quickQuote));
        fetchQuotes();
    }, []);

    return (
        <div>
            {/* Breadcrumbs are always displayed */}
            <Breadcrumbs currentStep={"Quotes"} />

            {/* Loading popup */}
            <Backdrop open={loading} style={{ zIndex: 1300 }} >
                <CircularProgress color="inherit" />
            </Backdrop>

            {!loading && (
                <div className="container-fluid g-0" style={{ marginTop: "24px" }}>
                    <div className="row gy-2">
                        <QuotesTable businessChargingCategory={userInfo.businessCategory} quotes={quotes} acceptQuote={acceptQuote} />
                    </div>
                </div>
            )}
        </div>
    );
}

export default BuildQuotePageResults;
